import React from 'react';

/**
 * StatusBadge component for consistent status indicators
 * Provides semantic color variants for different states
 */
const StatusBadge = ({ 
  children,
  variant = 'default',
  size = 'medium',
  className = '',
  ...props 
}) => {
  const variantClasses = {
    default: 'bg-accent/20 text-text-secondary',
    primary: 'bg-info-light text-info-dark',
    success: 'bg-success-light text-success-dark',
    warning: 'bg-warning-light text-warning-dark',
    danger: 'bg-danger-light text-danger-dark',
    info: 'bg-info-light text-info-dark',
    active: 'bg-success-light text-success-dark',
    inactive: 'bg-accent/20 text-text-secondary',
    pending: 'bg-warning-light text-warning-dark',
    completed: 'bg-success-light text-success-dark',
    cancelled: 'bg-danger-light text-danger-dark'
  };

  const sizeClasses = {
    small: 'px-2 py-1 text-xs',
    medium: 'px-3 py-1 text-sm',
    large: 'px-4 py-2 text-base'
  };

  return (
    <span 
      className={`inline-flex items-center font-medium rounded-full ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};

export default StatusBadge;
